'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = window.createjs.Container;
var Bitmap = window.createjs.Bitmap;
var Text = window.createjs.Text;
var Shape = window.createjs.Shape;
var Ease = window.createjs.Ease;

var Ball = function (_Container) {
    _inherits(Ball, _Container);

    function Ball(menu, node, pos) {
        _classCallCheck(this, Ball);

        var _this = _possibleConstructorReturn(this, (Ball.__proto__ || Object.getPrototypeOf(Ball)).call(this));

        Container.call(_this);
        _this.ballId = null;
        _this.menu = menu;
        _this.hasChildren = false;
        _this.hasDrawText = false;
        _this.tf = null;
        _this.tf2 = null;
        _this.textColor = '#333333';
        _this.textHoverColor = '#999999';
        _this.tfCont = new Container();
        _this.locked = false;
        //
        _this.hoverTime = 0;
        _this.isCounting = false;
        _this.isTooltipShowed = false;

        // data from JSON
        _this.name = node.name;
        _this.tagId = node.tagId;
        _this.heading = node.heading;
        _this.tagged = node.tagged;
        _this.description = node.description;

        _this.list = null;
        _this.parentList = null;
        _this.node = node;
        // circle
        _this.circle = null;
        _this.hover = null;
        if (pos === 'left') {
            _this.circle = new Bitmap(_this.menu.preloader.getResult('ball_left'));
            _this.hover = new Bitmap(_this.menu.preloader.getResult('ball_left_hover'));
        } else if (pos === 'middle') {
            _this.circle = new Bitmap(_this.menu.preloader.getResult('ball_middle'));
            _this.hover = new Bitmap(_this.menu.preloader.getResult('ball_middle_hover'));
        } else if (pos === 'right') {
            _this.circle = new Bitmap(_this.menu.preloader.getResult('ball_right'));
            _this.hover = new Bitmap(_this.menu.preloader.getResult('ball_right_hover'));
        }
        _this.addChild(_this.circle);
        _this.addChild(_this.hover);
        _this.hover.y = _this.circle.y = 20;
        _this.hover.x = _this.circle.x = -_this.circle.image.width / 2;
        if (_this.isIEBrowser) {
            _this.hover.x = _this.circle.x = -36;
        }
        _this.hover.alpha = 0;
        _this.createChildren();
        _this.circle.addEventListener('mouseover', function () {
            if (_this.hasChildren) {
                if (!_this.parentList.locked) {
                    document.body.style.cursor = 'pointer';
                    _this.mOver();
                }
            }
            // this.startCount();
        });
        _this.circle.addEventListener('mouseout', function () {
            if (!_this.parentList.locked) {
                document.body.style.cursor = '';
                _this.mOut();
            }
            // this.stopCount();
        });
        _this.circle.addEventListener('click', function (e) {
            if (!_this.parentList.locked) {
                _this.mClick(e);
            }
        });
        _this.circle.addEventListener('mouseup', function () {
            if (!_this.parentList.locked) {
                document.body.style.cursor = '';
                _this.mOut();
            }
        });
        _this.circle.addEventListener('mousedown', function () {
            if (_this.hasChildren) {
                if (!_this.parentList.locked) {
                    // TODO: this code is very bad for performance and should be reviewed
                    document.body.style.cursor = 'pointer';
                    _this.mOver();
                }
            }
        });
        return _this;
    }

    _createClass(Ball, [{
        key: 'mClick',
        value: function mClick(e) {
            if (e !== undefined) {
                e.stopImmediatePropagation();
            }
            if (this.hasChildren) {
                // save current navigation
                this.menu.pushTrackId(this.ballId);
                this.menu.shiftItem(this.list);
                this.menu.pushNav({ name: this.name, tagId: this.tagId });
                this.mOver();
                this.stopCount();
            }
        }
    }, {
        key: 'parentChange',
        value: function parentChange() {
            var pBall = this.parentList.parentBall;
            if (pBall) {
                if (pBall.list.members.length === 0) {
                    pBall.hasChildren = false;
                    pBall.circle.alpha = 0.7;
                }
            }
        }
    }, {
        key: 'dispose',
        value: function dispose() {
            this.removeAllEventListeners();
            this.circle.removeAllEventListeners();
        }
    }, {
        key: 'lock',
        value: function lock() {
            this.removeAllEventListeners('tick');
        }
    }, {
        key: 'unlock',
        value: function unlock() {
            this.addEventListener('tick', this.onTick.bind(this));
        }
    }, {
        key: 'reDraw',
        value: function reDraw() {
            if (this.hasDrawText) {
                this.hasDrawText = false;
                this.tfCont.removeAllChildren();
            }
            this.createText();
        }
    }, {
        key: 'setId',
        value: function setId(id) {
            this.ballId = id;
        }
    }, {
        key: 'mOver',
        value: function mOver() {
            if (this.hasChildren) {
                window.createjs.Tween.get(this.hover, { override: true }).to({ alpha: 0.8 }, 500);
                // mouse out the other
                var others = this.parentList.members;
                for (var i = 0; i < others.length; i++) {
                    if (others[i] !== this) {
                        others[i].mOut();
                    }
                }
            }
            // this.startCount();
        }
    }, {
        key: 'mOut',
        value: function mOut() {
            if (this.locked) {
                return;
            }
            window.createjs.Tween.get(this.hover, { override: true }).to({ alpha: 0 }, 500);
            // this.stopCount();
        }
    }, {
        key: 'createChildren',
        value: function createChildren() {
            if (this.node.rec) {
                this.list = new BallList(this.menu, this.node.rec);
                this.list.parentBall = this;
                this.hasChildren = true;
                this.circle.alpha = 1;
            } else {
                this.hasChildren = false;
                this.circle.alpha = 0.7;
            }
        }
    }, {
        key: 'createText',
        value: function createText() {
            if (this.hasDrawText) {
                return;
            }
            if (this.tagged) {
                this.tf = new Text(this.name, '400 13px Segoe ui,Helvetica Neue,Ubuntu,Arial', '#f5ab00');
            } else {
                this.tf = new Text(this.name, '400 13px Segoe ui,Helvetica Neue,Ubuntu,Arial', this.textColor);
            }
            this.tfCont.addChild(this.tf);
            this.tf.cache(-5, -5, this.tf.getMeasuredWidth() + 10, this.tf.getMeasuredHeight() + 10);
            // center
            this.tf.x = -this.tf.getMeasuredWidth() / 2;
            this.tf.hitArea = new Shape();
            this.tf.hitArea.graphics.clear().beginFill('#FFF').drawRect(0, 0, this.tf.getMeasuredWidth() + 30, this.tf.getMeasuredHeight() + 5);
            this.tf2 = new Text(this.name, '400 13px Segoe ui', this.textHoverColor);
            this.tfCont.addChild(this.tf2);
            this.tf2.cache(-5, -5, this.tf2.getMeasuredWidth() + 10, this.tf2.getMeasuredHeight() + 10);
            this.tf2.x = -this.tf2.getMeasuredWidth() / 2;
            this.tf2.visible = false;
            this.tf2.hitArea = new Shape();
            this.tf2.hitArea.graphics.clear().beginFill('#FFF').drawRect(0, 0, this.tf2.getMeasuredWidth() + 30, this.tf2.getMeasuredHeight() + 5);
            this.addChild(this.tfCont);
            this.tfCont.removeAllEventListeners();
            this.tfCont.addEventListener('mouseover', this.onTitleOver.bind(this));
            this.tfCont.addEventListener('mouseout', this.onTitleOut.bind(this));
            this.tfCont.addEventListener('click', this.onTitleClick.bind(this));
            this.hasDrawText = true;
        }
    }, {
        key: 'onTitleOver',
        value: function onTitleOver() {
            if (!(this.heading && this.menu.options.headings)) {
                document.body.style.cursor = 'pointer';
                this.tf2.visible = true;
                this.tf.visible = false;
            }
            this.startCount();
        }
    }, {
        key: 'onTitleOut',
        value: function onTitleOut() {
            if (!(this.heading && this.menu.options.headings)) {
                document.body.style.cursor = '';
                this.tf2.visible = false;
                this.tf.visible = true;
            }
            this.stopCount();
        }
    }, {
        key: 'onTitleClick',
        value: function onTitleClick() {
            var tagId = this.tagId,
                name = this.name,
                description = this.description,
                heading = this.heading,
                tagged = this.tagged;

            this.menu.hooks.onTitleClick({ tagId: tagId, name: name, description: description, heading: heading, tagged: tagged });
        }
    }, {
        key: 'startCount',
        value: function startCount() {
            this.isCounting = true;
            this.hoverTime = 0;
        }
    }, {
        key: 'stopCount',
        value: function stopCount() {
            this.isCounting = false;
            this.showTooltip(false);
            this.hoverTime = 0;
        }
    }, {
        key: 'onTick',
        value: function onTick(e) {
            if (this.isCounting) {
                this.hoverTime += e.delta;
                if (this.hoverTime > 200) {
                    this.showTooltip(true);
                }
            }
        }
    }, {
        key: 'showTooltip',
        value: function showTooltip(show) {
            var tagId = this.tagId,
                name = this.name,
                description = this.description,
                heading = this.heading,
                tagged = this.tagged;

            if (show) {
                if (this.isTooltipShowed) {
                    return;
                }
                this.isTooltipShowed = true;
                this.menu.hooks.onTitleMouseEnter({ tagId: tagId, name: name, description: description, heading: heading, tagged: tagged });
            } else {
                if (!this.isTooltipShowed) {
                    return;
                }
                this.isTooltipShowed = false;
                this.menu.hooks.onTitleMouseLeave({ tagId: tagId, name: name, description: description, heading: heading, tagged: tagged });
            }
        }
    }]);

    return Ball;
}(Container);

var BallList = function (_Container2) {
    _inherits(BallList, _Container2);

    function BallList(_ref, node) {
        var preloader = _ref.preloader,
            shiftItem = _ref.shiftItem,
            popTrackId = _ref.popTrackId,
            pushTrackId = _ref.pushTrackId,
            pushNav = _ref.pushNav,
            hooks = _ref.hooks,
            options = _ref.options;

        _classCallCheck(this, BallList);

        var _this2 = _possibleConstructorReturn(this, (BallList.__proto__ || Object.getPrototypeOf(BallList)).call(this));

        Container.call(_this2);
        _this2.itemWidth = 100;
        _this2.menu = { preloader: preloader, shiftItem: shiftItem, popTrackId: popTrackId, pushTrackId: pushTrackId, pushNav: pushNav, hooks: hooks, options: options };
        _this2.prelaoder = preloader;
        _this2.nodes = node;
        _this2.members = [];
        _this2.parentBall = null;
        _this2.listCont = new Container();
        _this2.listWidth = 0;
        _this2.locked = false;
        _this2.build();
        return _this2;
    }

    _createClass(BallList, [{
        key: 'isItemExist',
        value: function isItemExist(ball) {
            for (var i = 0; i < this.nodes.length; i++) {
                if (this.nodes[i].tagId === ball.tagId) {
                    return true;
                }
            }
            return false;
        }
    }, {
        key: 'build',
        value: function build() {
            // let rebuild = false;
            var oldMembers = [];
            if (this.members.length > 0) {
                // rebuild = true;
                for (var i = 0; i < this.members.length; i++) {
                    if (this.isItemExist(this.members[i])) {
                        oldMembers.push(this.members[i]);
                    }
                }
            }
            this.members = [];
            this.listCont.removeAllChildren();
            for (var _i = 0; _i < this.nodes.length; _i++) {
                var ball = null;
                var node = this.nodes[_i];
                var id = _i;
                for (var j = 0; j < oldMembers.length; j++) {
                    if (oldMembers[j].tagId === node.tagId) {
                        ball = oldMembers[j];
                        break;
                    }
                }
                if (ball === null) {
                    if (id === 0) {
                        ball = new Ball(this.menu, node, 'left');
                    } else if (id === this.nodes.length - 1) {
                        ball = new Ball(this.menu, node, 'right');
                    } else {
                        ball = new Ball(this.menu, node, 'middle');
                    }
                }
                // internal id, not the json id !!
                ball.setId(_i);
                this.members.push(ball);
                ball.parentList = this;
                this.listCont.addChild(ball);
            }
            this.arrangeBalls();
            this.listWidth = (this.members.length - 1) * this.itemWidth;
            this.listCont.x = -this.listWidth / 2;
            this.addChild(this.listCont);
        }
    }, {
        key: 'openChildRecursiveById',
        value: function openChildRecursiveById(ids) {
            // find the ball id => id
            var id = ids[0];
            var ball = null;
            for (var i = 0; i < this.members.length; i++) {
                if (this.members[i].ballId === id) {
                    ball = this.members[id];
                    break;
                }
            }
            if (ball === null) {
                return;
            }
            ball.mClick();
            ids.splice(0, 1);
            if (ids.length > 0) {
                if (ball.list !== undefined) {
                    ball.list.openChildRecursiveById(ids);
                }
            }
        }
    }, {
        key: 'arrangeBalls',
        value: function arrangeBalls() {
            var width = 0;
            var i = void 0;
            for (i = 0; i < this.members.length; i++) {
                var ball = this.members[i];
                ball.x = width;
                width += this.itemWidth;
            }
        }
    }, {
        key: 'getItemById',
        value: function getItemById(id) {
            var ball2 = null;
            for (var i = 0; i < this.members.length; i++) {
                var ball = null;
                ball = this.members[i];
                if (ball.tagId === id) {
                    return ball;
                }
                if (ball.list) {
                    ball2 = ball.list.getItemById(id);
                    if (ball2) {
                        return ball2;
                    }
                }
            }
            return ball2;
        }
    }, {
        key: 'changeTextColor',
        value: function changeTextColor(id, color) {
            var item = this.getItemById(id);
            item.tf.color = color;
            item.tf.updateCache();
            item.tf2.color = color;
            item.tf2.updateCache();
        }
    }, {
        key: 'resetTextColor',
        value: function resetTextColor(id) {
            var item = this.getItemById(id);
            item.tf.color = item.textColor;
            item.tf.updateCache();
            item.tf2.color = item.textHoverColor;
            item.tf2.updateCache();
        }
    }, {
        key: 'addItem2',
        value: function addItem2(newBall, parentId, ballIndex) {
            // This code is modified 13-06-2016 and is not tested. In case of failure roll back to the original.
            var id = newBall.tagId;
            var index = ballIndex;
            if (!index) {
                index = -1;
            }
            var newNode = newBall.node;
            if (parentId === '') {
                // check if exist
                for (var j = 0; j < this.nodes.length; j++) {
                    if (this.nodes[j].tagId === id) {
                        return true;
                    }
                }
                if (index > this.nodes.length) {
                    index = -1;
                }
                if (index === -1) {
                    this.nodes.push(newNode);
                } else {
                    this.nodes.splice(index, 0, newNode);
                }
                this.build();
                this.createText();
                return true;
            }
            var ball = null;
            for (var i = 0; i < this.members.length; i++) {
                ball = this.members[i];
                if (ball.tagId === parentId) {
                    if (!ball.node.rec) {
                        ball.node.rec = [];
                        ball.node.rec.push(newNode);
                        ball.createChildren();
                    } else {
                        // check if exist
                        for (var _j = 0; _j < ball.list.nodes.length; _j++) {
                            if (ball.list.nodes[_j].tagId === id) {
                                return true;
                            }
                        }
                        if (index === -1) {
                            ball.list.nodes.push(newNode);
                        } else {
                            ball.list.nodes.splice(index, 0, newNode);
                        }
                    }
                    ball.list.build();
                    ball.list.createText();
                    return true;
                }
                if (ball.list != null) {
                    var found = ball.list.addItem2(newBall, parentId, index);
                    if (found) {
                        return true;
                    }
                }
            }
            return false;
        }
    }, {
        key: 'addItem',
        value: function addItem(parentId, data, ballIndex) {
            // This code is modified 13-06-2016 and is not tested. In case of failure roll back to the original.
            var index = ballIndex;
            if (!index) {
                index = -1;
            }
            if (parentId === '') {
                // check if exist
                for (var j = 0; j < this.nodes.length; j++) {
                    if (this.nodes[j].tagId === data.tagId) {
                        return true;
                    }
                }
                var newNode = data;
                if (index > this.nodes.length) {
                    index = -1;
                }
                if (index === -1) {
                    this.nodes.push(newNode);
                } else {
                    this.nodes.splice(index, 0, newNode);
                }
                this.build();
                this.createText();
                return true;
            }
            var ball = null;
            for (var i = 0; i < this.members.length; i++) {
                ball = this.members[i];
                if (ball.tagId === parentId) {
                    var _newNode = data;
                    // not have children yet
                    if (!ball.node.rec) {
                        ball.node.rec = [];
                        ball.node.rec.push(_newNode);
                        ball.createChildren();
                    } else {
                        // check if exist
                        for (var _j2 = 0; _j2 < ball.list.nodes.length; _j2++) {
                            if (ball.list.nodes[_j2].tagId === data.tagId) {
                                return true;
                            }
                        }
                        if (index === -1) {
                            ball.list.nodes.push(_newNode);
                        } else {
                            ball.list.nodes.splice(index, 0, _newNode);
                        }
                    }
                    ball.list.build();
                    ball.list.createText();
                    return true;
                }
                if (ball.list != null) {
                    var found = ball.list.addItem(parentId, data, index);
                    if (found) {
                        return true;
                    }
                }
            }
            return false;
        }
    }, {
        key: 'removeItem',
        value: function removeItem(tagId) {
            var ball = null;
            for (var i = 0; i < this.nodes.length; i++) {
                var node = this.nodes[i];
                if (node.tagId === tagId) {
                    // find the removed ball
                    for (var j = 0; j < this.members.length; j++) {
                        ball = this.members[j];
                        if (ball.tagId === tagId) {
                            break;
                        }
                    }
                    this.nodes.splice(i, 1);
                    this.build();
                    this.createText();
                    ball.parentChange();
                    return ball;
                }
            }
            for (var _i2 = 0; _i2 < this.members.length; _i2++) {
                ball = this.members[_i2];
                if (ball.list != null) {
                    var foundBall = ball.list.removeItem(tagId);
                    if (foundBall != null) {
                        return foundBall;
                    }
                }
            }
            // not found
            return null;
        }
    }, {
        key: 'editItem',
        value: function editItem(id, data) {
            // loop the balls
            var ball = null;
            for (var i = 0; i < this.members.length; i++) {
                ball = this.members[i];
                if (ball.tagId === id) {
                    Object.assign(ball, data);
                    ball.reDraw();
                    return true;
                }
                if (ball.hasChildren) {
                    var found = ball.list.editItem(id, data);
                    if (found) {
                        return true;
                    }
                }
            }
            // not found
            return false;
        }
    }, {
        key: 'reset',
        value: function reset() {
            for (var i = 0; i < this.members.length; i++) {
                this.members[i].locked = false;
                this.members[i].mOut();
            }
        }
    }, {
        key: 'createText',
        value: function createText() {
            for (var i = 0; i < this.members.length; i++) {
                this.members[i].createText();
            }
        }
    }, {
        key: 'setX',
        value: function setX(x, scale) {
            var speed = (this.x - x) / 10;
            speed *= scale;
            var mspeed = 20;
            if (speed > 0 && speed > mspeed) {
                speed = mspeed;
            } else if (speed < 0 && speed < -mspeed) {
                speed = -mspeed;
            }
            this.x -= speed;
        }
    }, {
        key: 'lock',
        value: function lock() {
            this.locked = true;
            this.hitArea = new Shape();
            var w = 100 + this.listWidth;
            this.hitArea.graphics.clear().beginFill('#FFF').drawRect(-w / 2, 0, w, 100);
            this.hitArea.alpha = 0.01;
            this.addChild(this.hitArea);
            this.addEventListener('click', this.mClick.bind(this));
            for (var i = 0; i < this.members.length; i++) {
                this.members[i].lock();
            }
        }
    }, {
        key: 'unlock',
        value: function unlock() {
            this.locked = false;
            this.hitArea = null;
            this.removeAllEventListeners('click');
            for (var i = 0; i < this.members.length; i++) {
                this.members[i].unlock();
            }
        }
    }, {
        key: 'mOver',
        value: function mOver() {
            document.body.style.cursor = 'pointer';
        }
    }, {
        key: 'mOut',
        value: function mOut() {
            document.body.style.cursor = '';
        }
    }, {
        key: 'mClick',
        value: function mClick() {
            if (!this.locked) {
                return;
            }
            this.menu.popTrackId();
            this.menu.shiftItem(this);
        }
    }, {
        key: 'isParentInside',
        value: function isParentInside(list) {
            for (var i = 0; i < this.members.length; i++) {
                var ball = this.members[i];
                if (list.parentBall === ball) {
                    return true;
                }
            }
            return false;
        }
    }, {
        key: 'mOutAll',
        value: function mOutAll() {
            for (var i = 0; i < this.members.length; i++) {
                this.members[i].locked = false;
                this.members[i].mOut();
            }
        }
    }]);

    return BallList;
}(Container);

// TODO: This is some crazy ass code i don't want to touch...


var TaxonomyCanvas = function () {
    function TaxonomyCanvas(canvasElement, config) {
        _classCallCheck(this, TaxonomyCanvas);

        this.config = config;
        this.navPieces = [];
        this.canvasElement = canvasElement;
        this.stage = null;

        this.mouseX = -1;
        this.enableMouseScrolling = true;
        this.isIEBrowser = this.isIE();
        this.transition = Ease.quadInOut;

        // touch device
        this.isTouchDevice = null;
        this.isTouched = null;
        this.startTouchX = null;
        this.startListX = null;
        this.touchX = null;
        this.touchSpeed = 0;
        this.lastListPosition = 99999;
        this.track = [];
        this.dataName = 'menu_tracker';
        this.storageEnable = true;
        this.isInitalized = false;
    }

    _createClass(TaxonomyCanvas, [{
        key: 'create',
        value: function create(json) {
            var _this3 = this;

            var preloader = new window.createjs.LoadQueue(false);
            var manifest = [{ id: 'ball_left', src: '/taxonomy-img/ball_left.png' }, { id: 'ball_middle', src: '/taxonomy-img/ball_middle.png' }, { id: 'ball_right', src: '/taxonomy-img/ball_right.png' }, { id: 'ball_left_hover', src: '/taxonomy-img/ball_left_hover.png' }, { id: 'ball_middle_hover', src: '/taxonomy-img/ball_middle_hover.png' }, { id: 'ball_right_hover', src: '/taxonomy-img/ball_right_hover.png' }];
            preloader.loadManifest(manifest);
            preloader.on('complete', function () {
                var topItem = new BallList({
                    preloader: preloader,
                    shiftItem: _this3.shiftItem.bind(_this3),
                    popTrackId: _this3.popTrackId.bind(_this3),
                    pushTrackId: _this3.pushTrackId.bind(_this3),
                    pushNav: _this3.pushNav.bind(_this3),
                    hooks: {
                        onTitleClick: function onTitleClick(data) {
                            if (_this3.config.headings && data.heading) {
                                return;
                            }
                            _this3.config.onTitleClick && _this3.config.onTitleClick(data);
                        },
                        onTitleMouseEnter: function onTitleMouseEnter(data) {
                            _this3.config.onTitleMouseEnter && _this3.config.onTitleMouseEnter(data);
                        },
                        onTitleMouseLeave: function onTitleMouseLeave(data) {
                            _this3.config.onTitleMouseLeave && _this3.config.onTitleMouseLeave(data);
                        }
                    },
                    options: {
                        headings: _this3.config.headings
                    }
                }, json.rec);
                _this3.drawMenu(_this3.canvasElement, topItem);
                // this.isCreated = true;
                // this.updateNav();
                // this.props.onCreated && this.props.onCreated(this);
            }, this, true);
        }
    }, {
        key: 'triggerNavigate',
        value: function triggerNavigate() {
            if (this.isInitalized) {
                this.config.onNavigate && this.config.onNavigate(this.navPieces);
            }
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            if (this.stage) {
                createjs.Ticker.reset();
                this.stage.enableDOMEvents(false);
            }
        }
    }, {
        key: 'drawMenu',
        value: function drawMenu(canvas, topItem) {
            var _this4 = this;

            var width = canvas.parentElement.clientWidth;
            canvas.width = width;
            canvas.height = 400;
            this.stage = new window.createjs.Stage(canvas);
            this.stage.enableDOMEvents(true);
            this.setSize(width, 400);
            this.make(this.stage, topItem);
            this.stage.enableMouseOver(15);
            window.createjs.Ticker.setFPS(45);
            window.createjs.Ticker.addEventListener('tick', function (event) {
                if (!event.paused) {
                    _this4.stage.update(event);
                }
            });
            if (!this.isIE()) {
                createjs.Touch.enable(this.stage);
            }
            this.isTouchDevice = 'ontouchstart' in window || 'onmsgesturechange' in window;
            if (this.isTouchDevice) {
                canvas.addEventListener('touchstart', function (e) {
                    _this4.onTouchDown(e.changedTouches[0].pageX);
                }, false);
                canvas.addEventListener('touchmove', function (e) {
                    _this4.onTouchMove(e.changedTouches[0].pageX);
                }, false);
                canvas.addEventListener('touchend', function (e) {
                    _this4.onTouchUp();
                }, false);
            }
        }
    }, {
        key: 'isIE',
        value: function isIE() {
            var ua = navigator.userAgent;
            var tem = void 0;
            var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*([\d\.]+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+(\.\d+)?)/g.exec(ua) || [];
                return 'IE ' + (tem[1] || '');
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/([\.\d]+)/i)) != null) {
                M[2] = tem[1];
            }

            var str = M.join(' ');
            var browser = str.split(' ');
            if (browser[0] == 'MSIE') {
                return true;
            }
            if (browser[0] === 'IE') {
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: 'changeTextColor',
        value: function changeTextColor(id, color) {
            this.topItem.changeTextColor(id, color);
        }
    }, {
        key: 'resetTextColor',
        value: function resetTextColor(id) {
            this.topItem.resetTextColor(id);
        }
    }, {
        key: 'moveItem',
        value: function moveItem(data, newParentId) {
            var ball = this.topItem.removeItem(data.tagId);
            this.topItem.addItem2(ball, newParentId, -1);
        }
    }, {
        key: 'removeItem',
        value: function removeItem(tagId) {
            return this.topItem.removeItem(tagId);
        }
    }, {
        key: 'addItem',
        value: function addItem(parentId, data) {
            this.topItem.addItem(parentId, data, -1);
        }
    }, {
        key: 'editItem',
        value: function editItem(data) {
            this.topItem.editItem(data.tagId, data);
        }
    }, {
        key: 'clearData',
        value: function clearData() {
            this.reset();
            this.resetTrackingData();
        }
    }, {
        key: 'setDataId',
        value: function setDataId(id) {
            this.reset();
            this.dataName = id;
            this.track = this.getTrackingData();
            if (this.track != null && this.track.length > 0) {
                this.storageEnable = false;
                this.openPrevState();
                this.storageEnable = true;
            } else {
                this.resetTrackingData();
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.list = [null, null, this.topItem, null];
            this.showItems();
            this.curItem = this.topItem;
            this.curItem.reset();
            this.resetNav();
            this.pushNav('TaxonomyBuilder');
            this.resetTrackingData();
        }
    }, {
        key: 'setSize',
        value: function setSize(width) {
            var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;

            this.width = width;
            this.height = height;
        }
    }, {
        key: 'pushTrackId',
        value: function pushTrackId(id) {
            this.getTrackingData();
            this.track.push(id);
            this.saveTrackingData();
        }
    }, {
        key: 'popTrackId',
        value: function popTrackId() {
            this.getTrackingData();
            this.track.splice(this.track.length - 1, 1);
            this.saveTrackingData();
        }
    }, {
        key: 'resetTrackingData',
        value: function resetTrackingData() {
            if (!this.storageEnable) {
                return;
            }
            this.track = [];
            localStorage.setItem(this.dataName, this.track);
        }
    }, {
        key: 'saveTrackingData',
        value: function saveTrackingData() {
            if (!this.storageEnable) {
                return;
            }
            localStorage.setItem(this.dataName, JSON.stringify(this.track));
        }
    }, {
        key: 'getTrackingData',
        value: function getTrackingData() {
            var track = localStorage.getItem(this.dataName);
            if (track === '') {
                this.resetTrackingData();
                return this.track;
            }
            this.track = JSON.parse(track);
            return this.track;
        }
    }, {
        key: 'openPrevState',
        value: function openPrevState() {
            if (this.getTrackingData() == null) {
                this.resetTrackingData();
            }
            var ids = this.getTrackingData().slice();
            this.topItem.openChildRecursiveById(ids);
        }
    }, {
        key: 'pushNav',
        value: function pushNav(tag) {
            this.navPieces = [].concat(_toConsumableArray(this.navPieces), [tag]);
            this.triggerNavigate();
        }
    }, {
        key: 'popNav',
        value: function popNav() {
            this.navPieces = this.navPieces.slice(0, -1);
            this.triggerNavigate();
        }
    }, {
        key: 'resetNav',
        value: function resetNav() {
            this.navPieces = [];
        }
    }, {
        key: 'onTouchDown',
        value: function onTouchDown(x) {
            this.startTouchX = x;
            this.startListX = this.list[2].x;
            this.isTouched = true;
            this.touchX = x;
        }
    }, {
        key: 'onTouchUp',
        value: function onTouchUp() {
            this.isTouched = false;
            this.enableMouseScrolling = false;
        }
    }, {
        key: 'onTouchMove',
        value: function onTouchMove(x) {
            this.touchX = x;
        }
    }, {
        key: 'slideHorz',
        value: function slideHorz(delta) {
            var dx = this.touchX - this.startTouchX;
            var list = this.list[2];
            list.x = this.startListX + dx;
            this.touchSpeed = 0;
            if (this.lastListPosition < 99999) {
                this.touchSpeed = (list.x - this.lastListPosition) / (delta / 1000);
            }
            this.lastListPosition = list.x;
            if (list.x < -list.listWidth / 2 + this.width / 2) {
                list.x = -list.listWidth / 2 + this.width / 2;
            }
            if (list.x > list.listWidth / 2 + this.width / 2) {
                list.x = list.listWidth / 2 + this.width / 2;
            }
        }
    }, {
        key: 'slideHorzAfterUp',
        value: function slideHorzAfterUp(speed, delta) {
            var list = this.list[2];
            list.x += speed * delta / 1000;
            if (list.x < -list.listWidth / 2 + this.width / 2) {
                list.x = -list.listWidth / 2 + this.width / 2;
            }
            if (list.x > list.listWidth / 2 + this.width / 2) {
                list.x = list.listWidth / 2 + this.width / 2;
            }
        }
    }, {
        key: 'onTick',
        value: function onTick(e) {
            if (!this.list) {
                return;
            }
            if (this.isTouchDevice) {
                if (this.isTouched) {
                    this.touchArrange(e.delta);
                }
            }
            if (this.enableMouseScrolling) {
                if (this.list[2]) {
                    this.arrange(this.list[2]);
                }
                if (this.list[1]) {
                    this.arrange(this.list[1], 0.3);
                }
            }
        }
    }, {
        key: 'touchArrange',
        value: function touchArrange(delta) {
            if (this.list[2].listWidth < this.width) {
                return;
            }
            if (this.isTouched) {
                this.slideHorz(delta);
            }
        }
    }, {
        key: 'arrange',
        value: function arrange(list, scale) {
            if (!scale) {
                scale = 1;
            }
            if (list) {
                // var x = this.stage.mouseX;
                var x = this.mouseX;
                if (x < 0) {
                    return;
                }
                var newX = 1 / 2 * (this.width + (2 * (this.width - x) / this.width - 1) * list.listWidth);
                list.setX(newX, scale);
            }
        }
    }, {
        key: 'showItems',
        value: function showItems() {
            var _this5 = this;

            this.setListLock();
            this.stage.removeAllChildren();
            document.body.style.cursor = '';
            var moveItem = function moveItem(ballList, toProps) {
                window.createjs.Tween.get(ballList, { override: true }).to(toProps, 500, _this5.transition);
            };

            // initial
            if (this.list[2] && this.list[0] == null && this.list[1] == null && this.list[3] == null) {
                this.list[2].y = 370;
                this.list[2].x = this.width / 2;
                this.list[2].scaleX = 1.35;
                this.list[2].scaleY = 1.35;
            }

            if (this.list[0] != null) {
                var ballList = this.list[0];
                this.stage.addChild(ballList);
                moveItem(ballList, {
                    alpha: 0,
                    y: 30,
                    x: this.width / 2,
                    scaleX: 0.5,
                    scaleY: 0.5
                });
            }
            if (this.list[1] != null) {
                var _ballList = this.list[1];
                this.stage.addChild(_ballList);
                moveItem(_ballList, {
                    alpha: 0.5,
                    y: 80,
                    x: this.width / 2,
                    scaleX: 0.7,
                    scaleY: 0.7
                });
            }
            if (this.list[2] != null) {
                var _ballList2 = this.list[2];
                _ballList2.mOutAll();
                this.stage.addChild(_ballList2);
                moveItem(_ballList2, {
                    alpha: 1,
                    y: 160,
                    x: this.width / 2,
                    scaleX: 1,
                    scaleY: 1
                });
            }
            if (this.list[3] != null) {
                var _ballList3 = this.list[3];
                this.stage.addChild(_ballList3);
                moveItem(_ballList3, {
                    alpha: 0,
                    y: 270,
                    x: this.width / 2,
                    scaleX: 1.35,
                    scaleY: 1.35
                });
            }
        }
    }, {
        key: 'setListLock',
        value: function setListLock() {
            if (this.list[0]) {
                this.list[0].lock();
            }
            if (this.list[1]) {
                this.list[1].lock();
            }
            if (this.list[2]) {
                this.list[2].unlock();
            }
        }
    }, {
        key: 'shiftItem',
        value: function shiftItem(newItem) {
            newItem.createText();
            if (this.curItem.isParentInside(newItem)) {
                if (newItem.members.length > 0) {
                    this.list.shift();
                    this.list[2] = newItem;
                    this.curItem = newItem;
                    this.curItem.x = this.width / 2;
                    this.curItem.y = 280;
                    this.curItem.alpha = 0;
                    this.curItem.scaleX = this.curItem.scaleY = 1.35;
                }
                this.showItems();
                return;
            }
            var ball = this.curItem.parentBall;
            if (TaxonomyCanvas.isInList(ball, this.list[1])) {
                var lv1Parent = void 0;
                var lv0Parent = void 0;
                // lvl 2 go away
                this.list[2].lock();
                this.list[3] = this.list[2];
                if (this.list[1].parentBall == null) {
                    lv1Parent = null;
                } else {
                    lv1Parent = this.list[1].parentBall.parentList;
                }
                this.list[2] = this.list[1];
                this.list[1] = lv1Parent;
                this.curItem = this.list[2];
                this.curItem.reset();
                if (this.list[0] == null || this.list[0].parentBall == null) {
                    lv0Parent = null;
                } else {
                    lv0Parent = this.list[0].parentBall.parentList;
                }
                this.list[0] = lv0Parent;
                this.popNav();
                this.showItems();
            }
        }
    }, {
        key: 'make',
        value: function make(stage, topItem) {
            var _this6 = this;

            this.stage = stage;
            this.topItem = topItem;
            this.list = [null, null, this.topItem, null];
            this.showItems();
            this.curItem = topItem;
            this.topItem.createText();
            this.pushNav({ name: 'Home', tagId: null });
            this.stage.addEventListener('tick', this.onTick.bind(this));
            this.stage.addEventListener('stagemousemove', function (evt) {
                _this6.mouseX = evt.stageX;
            });
            this.track = this.getTrackingData();
            if (this.track != null && this.track.length > 0) {
                this.storageEnable = false;
                this.openPrevState();
                this.storageEnable = true;
            } else {
                this.resetTrackingData();
            }
            this.isInitalized = true;
            this.triggerNavigate();
        }
    }], [{
        key: 'isInList',
        value: function isInList(ball, list) {
            for (var i = 0; i < list.members.length; i++) {
                if (list.members[i] === ball) {
                    return true;
                }
            }
            return false;
        }
    }]);

    return TaxonomyCanvas;
}();

exports.default = TaxonomyCanvas;


//////////////////
// WEBPACK FOOTER
// ./src/components/TaxonomyCanvas/taxonomy.compiled.js
// module id = 823
// module chunks = 1